import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { memo } from 'react';
import classNames from 'classnames/bind';
import { spreadDangerousChildren } from "../utils/spreadDangerousChildren";
import { Preloader } from "../Preloader";
import style from "./styles.pcss";
import { getLoaderSize } from "./getLoaderSize";
var cn = classNames.bind(style);

/**
 * @param textColor, variants 'grey95', 'white',
 * 'contentAccent1', 'grey60', 'warning' are deprecated, transition is
 * grey95 - textIconElementPrimary,
 * grey60 - textIconElementSecondary,
 * warning - textIconElementError,
 * white - textIconElementPrimaryInvert,
 * contentAccent1 - accent02
 */
export var Button = /*#__PURE__*/memo(function (_ref) {
  var _cn, _cn2, _cn3;
  var children = _ref.children,
    disabled = _ref.disabled,
    _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading,
    extraAttributes = _ref.extraAttributes,
    fullWidth = _ref.fullWidth,
    icon = _ref.icon,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? function () {
      return false;
    } : _ref$onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'l' : _ref$size,
    textUppercase = _ref.textUppercase,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'button' : _ref$type,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'main' : _ref$variant,
    _ref$testName = _ref.testName,
    testName = _ref$testName === void 0 ? 'Button' : _ref$testName,
    rightSideNode = _ref.rightSideNode,
    rightIcon = _ref.rightIcon,
    _ref$textColor = _ref.textColor,
    textColor = _ref$textColor === void 0 ? 'textIconElementPrimary' : _ref$textColor,
    badge = _ref.badge,
    className = _ref.className;
  return /*#__PURE__*/React.createElement("button", _extends({}, extraAttributes, {
    className: cn('button', (_cn = {}, _defineProperty(_cn, "button--".concat(variant), Boolean(variant)), _defineProperty(_cn, "button--".concat(size), Boolean(size)), _defineProperty(_cn, 'button--uppercase', textUppercase), _defineProperty(_cn, "button--with-icon-".concat(size), children && (icon || rightIcon)), _defineProperty(_cn, 'button--full-width', fullWidth || rightSideNode), _defineProperty(_cn, "button--right-side-node--".concat(size), rightSideNode), _defineProperty(_cn, "button--".concat(textColor), !!textColor && variant === 'plain'), _cn), className),
    "data-component": testName,
    disabled: disabled || isLoading,
    onClick: onClick
    /* из-за динамического проброса типа дизейблим правило */
    // eslint-disable-next-line react/button-has-type
    ,
    type: type
  }), icon && /*#__PURE__*/React.createElement("div", {
    className: cn('button__icon', (_cn2 = {}, _defineProperty(_cn2, "button__icon--".concat(size), size), _defineProperty(_cn2, 'button__icon--loading', isLoading), _cn2))
  }, icon), children && /*#__PURE__*/React.createElement("span", _extends({
    className: cn('button__text', {
      'button__text--with-icon': Boolean(icon),
      'button__text--with-right-icon': Boolean(rightIcon),
      'button__text--loading': isLoading,
      'button__text--right-side-node': rightSideNode
    })
  }, spreadDangerousChildren(children))), isLoading && /*#__PURE__*/React.createElement(Preloader, {
    color: variant === 'tertiary-light' ? 'light' : 'dark',
    size: getLoaderSize(size)
  }), rightIcon && /*#__PURE__*/React.createElement("div", {
    className: cn('button__icon', (_cn3 = {}, _defineProperty(_cn3, "button__icon--".concat(size), size), _defineProperty(_cn3, 'button__icon--loading', isLoading), _cn3))
  }, rightIcon), rightSideNode && /*#__PURE__*/React.createElement("div", {
    className: cn("button__right-side-node--".concat(size), {
      'button__right-side-node--loading': isLoading
    })
  }, rightSideNode), badge && !disabled && !isLoading && /*#__PURE__*/React.createElement("div", {
    className: cn('button__badge')
  }, badge));
});
Button.displayName = Button.name;